import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Table, Tag } from 'antd'

import { formatBaht } from './format'

export const UNASSIGNED = 'unassigned'

export const assigneeKeyOf = (row) => (row.assignee ? row.assignee.id : UNASSIGNED)

const SELECTED_BACKGROUND = '#e6f4ff'

const countWithAmount = (count, money) => (
  <div>
    <div>{count}</div>
    {count > 0 && <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 12 }}>{formatBaht(money)}</div>}
  </div>
)

const AssigneeTable = ({ loading, onSelectAssignee, rows, selectedAssigneeId }) => {
  const { i18n } = useTranslation('highValueBaskets')
  const t = (key, options) => i18n.t(`highValueBaskets:${key}`, options)

  const columns = [
    {
      key: 'assignee',
      title: t('assignees.columns.assignee'),
      render: row => (row.assignee
        ? <strong>{row.assignee.fullName}</strong>
        : <Tag color="red">{t('assignees.unassigned')}</Tag>)
    },
    {
      key: 'total',
      align: 'right',
      title: t('assignees.columns.total'),
      sorter: (a, b) => a.totalCount - b.totalCount,
      render: row => countWithAmount(row.totalCount, row.total)
    },
    {
      key: 'open',
      align: 'right',
      title: t('assignees.columns.open'),
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.open.value - b.open.value,
      render: row => countWithAmount(row.openCount, row.open)
    },
    {
      key: 'needsFollowUp',
      align: 'right',
      title: t('assignees.columns.needsFollowUp'),
      sorter: (a, b) => a.needsFollowUpCount - b.needsFollowUpCount,
      render: row => (row.needsFollowUpCount > 0
        ? <Tag color="red">{row.needsFollowUpCount}</Tag>
        : 0)
    },
    {
      key: 'won',
      align: 'right',
      title: t('assignees.columns.won'),
      sorter: (a, b) => a.won.value - b.won.value,
      render: row => countWithAmount(row.wonCount, row.won)
    },
    {
      key: 'lost',
      align: 'right',
      dataIndex: 'lostCount',
      title: t('assignees.columns.lost')
    },
    {
      key: 'winRate',
      align: 'right',
      title: t('assignees.columns.winRate'),
      sorter: (a, b) => a.winRate - b.winRate,
      render: row => `${row.winRate}%`
    }
  ]

  return (
    <Table
      columns={columns}
      dataSource={rows}
      loading={loading}
      locale={{ emptyText: t('assignees.empty') }}
      onRow={row => ({
        onClick: () => onSelectAssignee(assigneeKeyOf(row) === selectedAssigneeId ? null : assigneeKeyOf(row)),
        style: {
          cursor: 'pointer',
          background: assigneeKeyOf(row) === selectedAssigneeId ? SELECTED_BACKGROUND : undefined
        }
      })}
      pagination={false}
      rowKey={assigneeKeyOf}
      scroll={{ x: true }}
      size="small"
    />
  )
}

AssigneeTable.propTypes = {
  loading: PropTypes.bool,
  onSelectAssignee: PropTypes.func.isRequired,
  rows: PropTypes.array.isRequired,
  selectedAssigneeId: PropTypes.string
}

AssigneeTable.defaultProps = {
  loading: false,
  selectedAssigneeId: null
}

export default AssigneeTable
